import React, { memo, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Select } from 'antd';
import { useRequestFilterCommands } from '../../../../model/commandsContext';
import {
  createOptionsForRender,
  optionCreators,
  useSetFilterChanged,
} from '../lib/utils';
import styles from '../SelectRoomsRow.module.scss';
import { compactMultiSelectTagProps } from '../../../primitives/selectTagProps';

const SelectFloor = ({ value, getPopupContainer, items }) => {
  const dispatch = useDispatch();
  const { setAddrFloorValue } = useRequestFilterCommands();

  const setFilterChanged = useSetFilterChanged();

  const handleChange = (value) => {
    dispatch(setAddrFloorValue(value));
    setFilterChanged();
  };

  const options = useMemo(
    () =>
      createOptionsForRender({
        items,
        createOption: optionCreators.floor,
      }),
    [items]
  );

  return (
    <Select
      {...compactMultiSelectTagProps}
      mode="multiple"
      allowClear={true}
      getPopupContainer={getPopupContainer}
      placeholder="Этажи"
      optionFilterProp="searchtext"
      style={{ width: 117 }}
      value={value}
      onChange={handleChange}
      dropdownClassName={styles.dropdownCN}
      optionLabelProp="label"
    >
      {options}
    </Select>
  );
};

export default memo(SelectFloor);
